import { render, staticRenderFns } from "./FiltersForm.vue?vue&type=template&id=630efc36&scoped=true&lang=pug&"
import script from "./FiltersForm.vue?vue&type=script&setup=true&lang=js&"
export * from "./FiltersForm.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./FiltersForm.vue?vue&type=style&index=0&id=630efc36&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630efc36",
  null
  
)

export default component.exports